import React, { useContext, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import MyInput from "../../Reusable/MyInput";
import Button from "../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../Reusable/BaseURL";
import ItemMasterPageForm from "../../masterFormPages/ItemMasterPageForm";
import { DivisionSelect } from "../../Reusable/DivisionSelect";
import { CategorySelect } from "../../Reusable/CategorySelect";
import { MaterialTypeSelect } from "../../Reusable/MaterialTypeSelect";
import { UnitSelect } from "../../Reusable/UnitSelect";
import { DisableContext } from "../../Context/DisableContext";
import { HSNSelectItemMaster } from "../../Reusable/HSNSelectItemMaster";

export default function Item() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);
  const { setDisableItemMaster, disableItemMaster } =
    useContext(DisableContext);
  const [division, setDivision] = useState("");
  const [category, setCategory] = useState("");
  const [materialType, setMaterialType] = useState("");
  const [hsnNo, setHsnNo] = useState("");
  const [hsnGstPercent, setHsnGstPercent] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [itemShortName, setItemShortName] = useState("");
  const [maintainMinQty, setMaintainMinQty] = useState("");
  const [unit, setUnit] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  // create
  async function Create(e) {
    e.preventDefault();
    if (!division || !category || !hsnNo || !itemName || !unit) {
      return toast.error("The required field is Empty !");
    }
    setSubmitDisable(true);
    const formData = new FormData();
    formData.append("division_id", division.value || "");
    formData.append("category_id", category.value || "");
    formData.append("material_type", materialType.label || "");
    formData.append("hsn_id", hsnNo.value || "");
    formData.append("item_code", itemCode);
    formData.append("item_name", itemName);
    formData.append("item_short_name", itemShortName);
    formData.append("maintain_min_qty", maintainMinQty);
    formData.append("unit_id", unit.value || "");

    const res = await fetch(`${BaseURL}/items`, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          setDivision("");
          setCategory("");
          setMaterialType("");
          setHsnNo("");
          setHsnGstPercent("");
          setItemCode("");
          setItemName("");
          setItemShortName("");
          setMaintainMinQty("");
          setUnit("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.item_name) {
          toast.error(createRes.error.message.item_name);
        } else if (createRes?.error?.message) {
          toast.error(createRes.error.message);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/items?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setTo(li.data.to);
          setFrom(li.data.from);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    if (editData) {
      toast.success("Going to update form..");

      setEditDisable(true);
      setChangingSelect(true);
      setSubmitAction("update");

      setDivision(editData.division || "");
      setCategory(editData.category || "");
      setMaterialType(editData.material_type || "");
      setHsnNo(editData.hsn_no || "");
      setHsnGstPercent(editData.hsn_gst_percent || "");
      setItemCode(editData.item_code || "");
      setItemName(editData.item_name || "");
      setItemShortName(editData.item_short_name || "");
      setMaintainMinQty(editData.maintain_min_qty || "");
      setUnit(editData.unit || "");
      setEditDisable(false);

      // TOP SCROLLING ==========
      // const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
      });
      // };
      // toast.success("Go to update form")
    } else {
      setChangingSelect(false);
      setEditDisable(false);
    }
  }

  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    if (!division || !category || !hsnNo || !itemName || !unit) {
      return toast.error("The required field is Empty !");
    }
    setUpdateDisable(true);
    const formData = {
      division_id: division.value || "",
      category_id: category.value || "",
      unit_id: unit.value || "",
      hsn_id: hsnNo.value || "",
      item_name: itemName,
      item_code: itemCode,
      item_short_name: itemShortName,
      maintain_min_qty: maintainMinQty,
      material_type: materialType.label || "",
    };

    const updRes = await fetch(`${BaseURL}/items/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setDivision("");
          setCategory("");
          setMaterialType("");
          setHsnNo("");
          setHsnGstPercent("");
          setItemCode("");
          setItemName("");
          setItemShortName("");
          setMaintainMinQty("");
          setUnit("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.status === false) {
          setUpdateDisable(false);
        }
        if (upd?.error?.message.item_name) {
          toast.error(upd.error.message.item_name);
        } else if (upd?.error?.message) {
          toast.error(upd.error.message);
        }
      });
  }

  function cancelUpdate() {
    setSubmitAction("submit");
    setDivision("");
    setCategory("");
    setMaterialType("");
    setHsnNo("");
    setHsnGstPercent("");
    setItemCode("");
    setItemName("");
    setItemShortName("");
    setMaintainMinQty("");
    setUnit("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Item Master
          </div>
          {allPermiss?.includes("master-item-itemmaster-create") && (
            <div className="">
              <div className="">
                <form action="" className="my-4 mb-8">
                  {/* <div className={`my-3 px-2`}></div> */}

                  <div
                    className={
                      "grid gap-x-3 grid-cols-1 md:grid-cols-3 px-2 py-1.5 " +
                      (darkTheme ? "bg-pink-500" : "bg-[#8CDDCD]")
                    }
                  >
                    <div className="mb-2">
                      <label>
                        Division{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <DivisionSelect
                        selectedOption={division}
                        setSelectedOption={setDivision}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                      />
                    </div>
                    <div className="mb-2">
                      <label>
                        Category{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <CategorySelect
                        selectedOption={category}
                        setSelectedOption={setCategory}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                      />
                    </div>

                    <div className="mb-2">
                      <label>Material Type</label>
                      <MaterialTypeSelect
                        selectedOption={materialType}
                        setSelectedOption={setMaterialType}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                      />
                    </div>
                  </div>

                  <div
                    className={
                      "grid gap-x-3 grid-cols-1 md:grid-cols-3 px-2 py-1.5 " +
                      (darkTheme ? "bg-orange-500" : "bg-violet-200")
                    }
                  >
                    <MyInput
                      label="Item Name"
                      type="text"
                      className="w-full"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                      mendatory="*"
                    />
                    <div className="mb-2">
                      <label className="">
                        Item Short Name{" "}
                        <button
                          type="button"
                          className="text-[13px] bg-green-600 text-white py-0.5 rounded-xl px-1"
                          onClick={() => setItemShortName(itemName)}
                        >
                          Same as name
                        </button>
                      </label>
                      <input
                        type="text"
                        className={`w-full border uppercase rounded-lg py-[8px] px-3 outline-none border-gray-500 bg-[#ffff]`}
                        value={itemShortName}
                        onChange={(e) => setItemShortName(e.target.value)}
                      />
                    </div>

                    <MyInput
                      label="Item Code"
                      type="text"
                      className="w-full"
                      value={itemCode}
                      onChange={(e) => setItemCode(e.target.value)}
                      mendatory="*"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-3 mb-4 px-2 bg-[#8CDDCD] py-1.5">
                    <div className="mb-2">
                      <label>
                        HSN No.{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <HSNSelectItemMaster
                        selectedOption={hsnNo}
                        setSelectedOption={setHsnNo}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                      />
                    </div>
                    <div className="mb-2">
                      <label>
                        Unit <span className="text-red-500 font-bold">*</span>
                      </label>
                      <UnitSelect
                        selectedOption={unit}
                        setSelectedOption={setUnit}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                      />
                    </div>
                    <MyInput
                      label="Maintain min qty"
                      type="number"
                      className="w-full"
                      value={maintainMinQty}
                      onChange={(e) => setMaintainMinQty(e.target.value)}
                      inputMode="numeric"
                      pattern="^-?\d+(\.\d{1,2})?$"
                    />
                  </div>

                  <div className="px-2">
                    {allPermiss?.includes("master-item-itemmaster-create") &&
                      submitAction === "submit" && (
                        <div className="flex items-center justify-center gap-x-1">
                          <Button
                            disabled={submitDisable}
                            type="submit"
                            onClick={(e) => Create(e)}
                          >
                            {submitDisable ? "Wait.." : "Submit"}
                          </Button>
                          <Button type="button" onClick={() => cancelUpdate()}>
                            Clear
                          </Button>
                        </div>
                      )}
                    {allPermiss?.includes("master-item-itemmaster-update") &&
                      submitAction === "update" && (
                        <div className="flex items-center justify-center gap-x-1">
                          <Button
                            disabled={updateDisable || disableItemMaster}
                            type="submit"
                            onClick={(e) => updateARecord(e, getId)}
                          >
                            {updateDisable ? "Wait.." : "Update"}
                          </Button>
                          <Button onClick={() => cancelUpdate()}>Cancel</Button>
                        </div>
                      )}
                  </div>
                </form>
              </div>
            </div>
          )}

          {allPermiss?.includes("master-item-itemmaster-view") && (
            <div className="w-full px-2">
              <ItemMasterPageForm
                editBtn={editBtn}
                firstPageList={firstPageList}
                links={links}
                firstPage={firstPage}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                editDisable={editDisable}
              />
            </div>
          )}

          {/* PAGE DISABLE  */}
          {disableItemMaster && (
            <div className="fixed top-0 left-0 right-0 bottom-0 z-[8000] bg-white h-full flex items-center justify-center">
              Fetching..
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
